/** @jsx jsx */
/** @jsxFrag */
import { ClassNames, jsx } from '@emotion/react';
import React from 'react';
import { Contact } from 'types/ContactData';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ContactCardProps extends React.HTMLAttributes<HTMLDivElement> {
  contact: Contact;
}

const ContactCard = React.forwardRef<HTMLDivElement, ContactCardProps>(({ contact: { name, sales, company } }, ref) => {
  return (
    <ClassNames>
      {({ theme }) => (
        <div
          ref={ref}
          css={{
            ...theme.typography.body1,
            '&:nth-of-type(4n+1)': { background: '#a0bc4d' },
            '&:nth-of-type(4n+2)': { background: '#85b752' },
            '&:nth-of-type(4n+3)': { background: '#509c51' },
            '&:nth-of-type(4n+4)': { background: '#327242' },
            '@media(min-width: 425px)': {
              fontSize: 16,
            },
            '@media(min-width: 600px)': {
              maxWidth: 300,
              width: 'calc(50% - 8px)',
            },
            '@media(min-width: 960px)': {
              margin: theme.spacing(1),
              padding: theme.spacing(2),
              width: 'calc(25% - 16px)',
            },
            borderRadius: 3,
            color: theme.palette.common.white,
            fontSize: 12,
            margin: theme.spacing(0.5),
            padding: theme.spacing(2),
            width: 'calc(100% - 8px)',
          }}
        >
          <div>{name}</div>
          <div
            css={{
              '& > a': {
                '&:hover': { textDecoration: 'underline' },
                color: theme.palette.common.white,
                lineHeight: '22px',
                textDecoration: 'none',
              },
              display: 'flex',
              flexDirection: 'column',
              marginTop: theme.spacing(2),
            }}
          >
            {sales?.phone && sales?.email && (
              <>
                <a href={`tel:${sales.phone}`}>{sales.phone}</a>
                <a href={`mailto:${sales.email}`}>{sales.email}</a>
              </>
            )}
          </div>
          {company?.street && company?.city && (
            <div css={{ fontSize: 12, marginTop: theme.spacing(4) }}>
              {company.street}, {company.city} <br />
              {company.country}
            </div>
          )}
        </div>
      )}
    </ClassNames>
  );
});

export default ContactCard;
